﻿import { App, Action } from './app.js'
import * as Helper from '../helper.js'

// Search addresses
/*
Action.create({
	name: 'address page filter',
	handler: async function (resolve, _reject, data)
	{
		App.Store.pagingReset('address')

		const query = {}
		if (data.filter)
			Object.entries(data.filter).forEach(entry => query[`filter[${entry[0]}]`] = entry[1])

		try
		{
			await App.Store.page(data.type, 1, data.size, query)
		}
		catch (err)
		{
			if (Array.isArray(err.data) && App.Store.paging(data.type).current)
				delete App.Store.paging(data.type).current // Force no results display instead of last good page
		}

		return resolve(data)
	}
})*/

// Change pages of a store-powered grid
Action.create({
	name: 'store page filter',
	handler: async function (resolve, _reject, data)
	{
		const query = {}
		if(data.filter)
			Object.entries(data.filter).forEach(entry => query[`filter[${entry[0]}]`] = entry[1])
		if (query['filter[to]'])
			query['filter[to]'] = moment(query['filter[to]']).endOf('day').format()
		if(data.include)
			query.include = Object.keys(data.include).join(',')
		try
		{
			await App.Store.page(data.type, 1, data.size, query)
			document.querySelector(`[data-type="${data.type}"][ui-action="store page filter"]`).querySelectorAll('[ui-action="order report export"]').forEach(e => e.disabled = false)
			return resolve(data)
		} catch (err)
		{
			if (Array.isArray(err.data))
			{
				if (App.Store.paging(data.type).current)
					delete App.Store.paging(data.type).current // Force no results display instead of last good page
			}
			else
			{
				document.querySelector(`[data-type="${data.type}"][ui-action="store page filter"]`).querySelectorAll('[ui-action="order report export"]').forEach(e => e.disabled = true)
				App.Component.HandleErrors(err)
			}

			return resolve(data)
		}
	}
})

Action.create({
	name: 'store page',
	handler: async function (resolve, _reject, data)
	{
		try
		{
			if (data.page)
			{
				const qs = {}
				let include = []

				if (data.endpoint)
				{
					const params = new URLSearchParams(data.endpoint.split('?')[1])
					for (const entry of params.entries())
					{
						if (entry[0].indexOf('page') >= 0)
							continue
						qs[entry[0]] = entry[1]
					}
				}

				if (data.type === 'customercatalog')
				{
					include = ['product', 'product.image']
					if (Helper.hasRole('Registered'))
					{
						include.push('product.child') // "Associated Products" of a "Grouped Product"
						include.push('product.price')
						include.push('product.promotion')
						include.push('product.variant')
					}
				}

				if (include.length)
					qs.include = include.join(',')

				let page = data.page || 1
				let size = data.size || (data.type == 'customercatalog' ? 9 : 10)

				await App.Store.page(data.type, page, size, qs)
			}
			else
			{
				await App.Store.fetchUrl(data.endpoint, data.type, data)
			}
		}
		catch (err)
		{
			App.Component.HandleErrors(err)
		}

		resolve(data)
	}
})

Action.create({
	name: 'tab show',
	handler: async function (resolve, _reject, data)
	{
		const pane = document.querySelector('#' + data.pane + '.tab-pane')
		console.log('tab show', { data, pane, active: pane.classList.contains('active') })
		if (pane)
		{
			// Deactivate all sibling panes
			pane.parentElement.querySelectorAll('.tab-pane.active').forEach(el => el.classList.remove('active'))
			// Activate requested pane
			pane.classList.add('active')
		}

		return resolve(data)
	}
})
